import { render, staticRenderFns } from "./purchase-sector.vue?vue&type=template&id=75b09bb6&"
import script from "./purchase-sector.vue?vue&type=script&lang=js&"
export * from "./purchase-sector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports